/*
 * menu.js -- hamburger + overlay panel mobilniho menu (plan 07-03,
 * opravna davka 07-07 body 1, 2, 9, 10).
 *
 * CO TENHLE MODUL JE A CO NENI
 *
 * NENI to nositel navigace. Navigaci nese svisly seznam v `.hbar`, ktery
 * funguje uplne bez skriptu (kontrakt B, plan 06-13). Tenhle modul je
 * ENHANCEMENT: teprve on zapina hamburger a otevira panel, ktery je v HTML
 * vzdy pritomny, ale s atributem `hidden`.
 *
 * PROC `menu-ready` (07-07, bod 1)
 * Trida `js` se na <html> dostane VZDY -- pridava ji inline skript v <head>,
 * ktery na bundlu nezavisi. Kdyz se bundle nenacte (sit, CSP, proxy) nebo
 * kdyz `init()` vyhodi vyjimku, byla do 07-06 navigace schovana a hamburger
 * viditelny, ale mrtvy. `init()` proto pridava `menu-ready` az NA SVEM KONCI,
 * tedy jen po uspesne inicializaci; CSS na te tride vesi viditelnost
 * hamburgeru a casovy fallback, ktery po 2 s svislou navigaci zase odkryje.
 * Poradi radku v `init()` je tim PODSTATNE, ne kosmeticke.
 *
 * PROC SE `hidden` ODEBIRA JEN V open()
 * Kdyby si ho init odebral "aby s panelem mohl pracovat", panel by pri
 * pomalem nacteni probliknul rozbaleny pres celou stranku (FOUC). `hidden`
 * je vychozi stav v markupu a mimo open()/close() se na nej nesaha.
 *
 * PROC RUCNI FOCUS TRAP A RUCNI INERT
 * `inert` je Chrome 102 / Safari 15.5 / Firefox 112 -- mimo matici podpory
 * projektu (Chrome 90, Safari 14.1, Firefox ESR 115). Modul ho proto
 * feature-detekuje a bez nej pouzije fallback `aria-hidden` + `tabindex=-1`.
 * Knihovna typu `focus-trap` by byla prvni runtime zavislost sablony, kterou
 * kontrakt A7 nechce. Hamburger je v seznamu fokusovatelnych ZAMERNE,
 * prestoze je MIMO panel: v otevrenem stavu je to krizek.
 *
 * PROC iOS-SAFE SCROLL-LOCK (07-07, bod 9)
 * `body { overflow: hidden }` na iOS Safari scroll nezastavi -- stranka se
 * pod panelem dal roluje. Zamek proto navic prepne telo na `position: fixed`
 * s ulozenym `scrollY` v `top`. CSS pravidlo zustava jako zaklad pro
 * desktopova okna (kompenzace scrollbaru).
 *
 * PROC TU NENI JEDINY LOKALIZOVANY RETEZEC
 * Popisky hamburgeru pro oba stavy nese markup v `data-label-open` /
 * `data-label-close` (header.php). Texty drzi registr Textu webu, sablona
 * zna jen klice -- bundl proto neobsahuje zadnou copy a jeji zmena
 * nevyzaduje rebuild JS.
 *
 * BEZPECNOST (threat model 07-03, 07-07)
 * Zadny `innerHTML`. Stav na <body> vyhradne pres `setState()` ze state.js
 * (verejny kontrakt pro GTM chatbot widget). Objekt predavany do
 * `history.pushState()` je KONSTANTA, nikdy interpolovany uzivatelsky
 * retezec. Inert fallback si pamatuje PRESNE ty prvky, kterym atribut sam
 * nasadil (marker `data-th-inert-tabindex`), takze `close()` neuklidi nic,
 * co tam bylo uz predtim (hrozba T-07-07-01).
 */

import { setState, hasState } from './state.js';

/*
 * Selektor fokusovatelnych prvku. `[tabindex]:not([tabindex="-1"])` chyti
 * i prvky, kterym tabindex prida budouci komponenta; `:not([disabled])`
 * vynecha vypnuta pole, ktera fokus neprijmou.
 */
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

const PANEL_ID = 'th-mobile-panel';
const BURGER_SELECTOR = '.hburger';
const STATE = 'menu-open';

/** Trida na <html>, kterou CSS pozna uspesnou inicializaci (07-07, bod 1). */
const READY_CLASS = 'menu-ready';

/** Marker prvku, kterym tabindex nasadil inert fallback (a jen tem). */
const INERT_MARK = 'thInertTabindex';

/**
 * Hranice, nad kterou overlay menu neexistuje (desktopova navigace je
 * v lite). Tataz hodnota jako tvrde `display: none` v chrome.css -- kdyby
 * se rozesly, zustal by pri zmene sirky zamceny scroll bez viditelneho
 * panelu.
 */
const DESKTOP_QUERY = '(min-width: 1024px)';

let panel = null;
let burger = null;

/*
 * Pushnuli jsme do historie vlastni zaznam? Drzi se to jako priznak, aby
 * close() vedelo, jestli ma volat history.back() (zavreni tlacitkem musi
 * zaznam uklidit, jinak by dalsi Back nevedl zpet na predchozi stranku).
 */
let pushedHistory = false;

/** Prvky, kterym open() nasadil `inert` (fallback: `aria-hidden`). */
let inertedRoots = [];

/** Prvky, kterym fallback nasadil `tabindex="-1"` (vc. hlavicky). */
let taggedFocusables = [];

/** Pozice stranky v okamziku zamceni scrollu (07-07, bod 9). */
let lockScrollY = 0;

/**
 * Je menu otevrene?
 *
 * Cte se STAV NA BODY, ne interni promenna modulu: stav je verejny kontrakt
 * a dve nezavisle evidence tehoz by se driv nebo pozdeji rozesly.
 *
 * @return {boolean}
 */
function isOpen() {
	return hasState(STATE);
}

/**
 * Umi prohlizec atribut `inert`?
 *
 * Feature-detect, ne verze prohlizece: matice se casem posune a modul se
 * ma prepnout sam.
 *
 * @return {boolean}
 */
function supportsInert() {
	return 'inert' in document.createElement('div');
}

/**
 * Fokusovatelne prvky trapu: hamburger + viditelne prvky panelu.
 *
 * `offsetParent !== null` vyhazuje skryte prvky (napr. jazykovy prepinac,
 * kdyz Polylang nic nevrati). Seznam se pocita az v okamziku Tabu, ne pri
 * open() -- panel muze obsahovat prvky, ktere se objevi pozdeji.
 *
 * @return {Element[]}
 */
function focusables() {
	const inPanel = Array.prototype.filter.call(
		panel.querySelectorAll(FOCUSABLE),
		(el) => el.offsetParent !== null
	);

	return [burger].concat(inPanel);
}

/**
 * Vyradi jeden podstrom z pristupnostniho stromu i z tab poradi.
 *
 * @param {Element} root Prvek k vyrazeni.
 * @param {boolean} useInert true = nativni `inert`, false = fallback.
 * @return {void}
 */
function makeInert(root, useInert) {
	if (useInert) {
		root.inert = true;
		inertedRoots.push(root);

		return;
	}

	root.setAttribute('aria-hidden', 'true');
	inertedRoots.push(root);
	tagFocusablesIn(root);
}

/**
 * Fallback: vsem fokusovatelnym potomkum nasadi `tabindex="-1"`.
 *
 * ZNACKA JE PODMINKA, NE OZDOBA: bez ni by `close()` sebrala tabindex
 * i prvkum, ktere ho mely uz predtim (skryte prvky komponent, budouci
 * karusely) -- tise by tim rozbila jejich vlastni poradi (T-07-07-01).
 *
 * @param {Element} root Koren podstromu.
 * @return {void}
 */
function tagFocusablesIn(root) {
	const items = root.querySelectorAll(FOCUSABLE);
	for (let i = 0; i < items.length; i += 1) {
		const el = items[i];
		if (el.hasAttribute('tabindex')) {
			continue;
		}
		el.setAttribute('tabindex', '-1');
		el.dataset[INERT_MARK] = '1';
		taggedFocusables.push(el);
	}
	if (root.matches(FOCUSABLE) && !root.hasAttribute('tabindex')) {
		root.setAttribute('tabindex', '-1');
		root.dataset[INERT_MARK] = '1';
		taggedFocusables.push(root);
	}
}

/**
 * Vyradi vsechno mimo hlavicku a panel + neovladatelne prvky hlavicky.
 *
 * Hlavicka jako celek vyrazena BYT NESMI -- je v ni krizek, tedy jediny
 * ovladaci prvek otevreneho dialogu. Vyradi se proto jeji obsah KROME
 * hamburgeru (logo, telefon, kontaktni cipy na 768-1023 px). Vizual se
 * nemeni, `pointer-events: none` resi chrome.css.
 *
 * @return {void}
 */
function isolateDocument() {
	const useInert = supportsInert();
	const header = burger.closest('header');
	const children = document.body.children;

	for (let i = 0; i < children.length; i += 1) {
		const node = children[i];
		if (node === panel || node === header) {
			continue;
		}
		makeInert(node, useInert);
	}

	if (!header) {
		return;
	}

	const inHeader = header.querySelectorAll(FOCUSABLE);
	for (let i = 0; i < inHeader.length; i += 1) {
		const el = inHeader[i];
		if (el === burger || burger.contains(el)) {
			continue;
		}
		el.setAttribute('aria-hidden', 'true');
		inertedRoots.push(el);
		if (!el.hasAttribute('tabindex')) {
			el.setAttribute('tabindex', '-1');
			el.dataset[INERT_MARK] = '1';
			taggedFocusables.push(el);
		}
	}
}

/**
 * Presny opak `isolateDocument()`.
 *
 * @return {void}
 */
function restoreDocument() {
	for (let i = 0; i < inertedRoots.length; i += 1) {
		const node = inertedRoots[i];
		node.inert = false;
		node.removeAttribute('aria-hidden');
	}
	inertedRoots = [];

	for (let i = 0; i < taggedFocusables.length; i += 1) {
		const el = taggedFocusables[i];
		if (el.dataset[INERT_MARK] === '1') {
			el.removeAttribute('tabindex');
			delete el.dataset[INERT_MARK];
		}
	}
	taggedFocusables = [];
}

/**
 * Klavesnice v otevrenem stavu: Escape zavira, Tab cykli uvnitr.
 *
 * Posluchac visi na DOKUMENTU, ne na panelu -- hamburger je v hlavicce,
 * tedy mimo panel, a Tab z nej by jinak vypadl ven z trapu.
 *
 * @param {KeyboardEvent} event Udalost.
 * @return {void}
 */
function onKeydown(event) {
	if ('Escape' === event.key || 'Esc' === event.key) {
		close();
		return;
	}

	if ('Tab' !== event.key) {
		return;
	}

	const items = focusables();
	if (!items.length) {
		return;
	}

	const first = items[0];
	const last = items[items.length - 1];

	if (event.shiftKey && document.activeElement === first) {
		last.focus();
		event.preventDefault();
	} else if (!event.shiftKey && document.activeElement === last) {
		first.focus();
		event.preventDefault();
	}
}

/**
 * Druha pojistka trapu (07-07, bod 2): fokus, ktery se do dokumentu dostal
 * jinak nez Tabem (klik, `focus()` z ciziho skriptu, prechod z adresniho
 * radku), se vrati do panelu.
 *
 * Hamburger je ZAMERNE povoleny -- v otevrenem stavu je to krizek dialogu.
 *
 * @param {FocusEvent} event Udalost.
 * @return {void}
 */
function onFocusOutside(event) {
	const target = event.target;
	if (!target || target === burger || panel.contains(target) || burger.contains(target)) {
		return;
	}

	const items = focusables();
	(items.length > 1 ? items[1] : burger).focus();
}

/**
 * Android Back / gesto zpet zavira menu misto opusteni stranky.
 *
 * Zavreni je tady VZDY bez dalsiho pushState (parametr `true`), jinak by
 * vznikla smycka pushState -> popstate -> pushState.
 *
 * @return {void}
 */
function onPopstate() {
	pushedHistory = false;

	if (isOpen()) {
		close(true);
	}
}

/**
 * Prekroceni desktopove hranice pri otevrenem menu.
 *
 * Nad 1024 px je panel tvrde `display: none` a hamburger skryty -- kdyby
 * stav `menu-open` prezil, zustalo by telo se zamcenym scrollem a bez
 * jakehokoli ovladaciho prvku, kterym by se odemklo.
 *
 * @return {void}
 */
function onDesktop() {
	if (isOpen()) {
		close();
	}
}

/**
 * Otoceni zarizeni pri zamcenem scrollu (07-07, bod 9).
 *
 * `lockScrollY` se NEPREPOCITAVA -- pozice v dokumentu se otocenim nemeni,
 * meni se jen vyska viewportu. Prepocitava se jen `top`, aby ho engine po
 * zmene metrik znovu aplikoval.
 *
 * @return {void}
 */
function onLockOrientation() {
	if (!isOpen()) {
		return;
	}
	document.body.style.top = '-' + lockScrollY + 'px';
}

/**
 * Klik na kotvu uvnitr panelu (07-07, bod 10).
 *
 * Odkaz na tutez stranku (`#kotva`, `/#poptavka`) zmeni jen hash, takze
 * stranka se nenacte znovu a menu by zustalo otevrene pres cil, na ktery
 * uzivatel prave klikl.
 *
 * DRUHY PARAMETR `close()` JE TU ZAMERNE `true` (oprava 1.27.11, polozka
 * 2 -- kotva mirila jinam). Klik na tenhle odkaz NENI jen zavreni panelu,
 * je to SKUTECNA navigace: prohlizec na `<a href="#…">` / `/#…` jako
 * DEFAULT AKCI TEHOZ KLIKU sam zmeni hash a zalozi VLASTNI zaznam
 * historie s cilovym scrollem. Kdyby `close()` hned nato zavolala (jako
 * pri zavreni Escapem/klikem mimo/hamburgerem) `history.back()`, vratila
 * by prohlizec ZPATKY PRES tenhle cerstvy zaznam na stav pred otevrenim
 * menu -- hash by zmizel (zmereno: `location.hash` po kliku prazdny) a
 * scroll by pri syntetickem kliku spadl az na 0, pri realnem tapu skoncil
 * pod hlavickou o vysku hlavicky vic (obe varianty = "kotva mirila
 * jinam"). Bez `history.back()` tu zustane jeden neskodny navic zaznam ve
 * stacku (tatoz URL, jen bez hashe) -- Back tlacitko z `/#jak-to-probiha`
 * pak na opusteni homepage potrebuje o jeden krok navic, coz je prijatelna
 * cena za to, ze kotva vubec doleti tam, kam uzivatel miril.
 *
 * @param {MouseEvent} event Udalost.
 * @return {void}
 */
function onPanelClick(event) {
	const target = event.target;
	if (!target || 'function' !== typeof target.closest) {
		return;
	}

	const link = target.closest('a[href]');
	if (!link) {
		return;
	}

	const href = link.getAttribute('href') || '';
	if (/^#/.test(href) || href.indexOf('/#') !== -1) {
		close(false, true);
	}
}

/**
 * Sirka scrollbaru, ktera po zamceni scrollu zmizi.
 *
 * Bez kompenzace by se pri otevreni menu cely obsah skocil doprava
 * (na mobilu je overlay scrollbar nulovy, na uzkem desktopovem okne ne).
 *
 * @return {number} Sirka v pixelech, 0 kdyz scrollbar misto nezabira.
 */
function scrollbarGap() {
	const gap = window.innerWidth - document.documentElement.clientWidth;

	return gap > 0 ? gap : 0;
}

/**
 * Zamkne rolovani zpusobem, ktery funguje i na iOS (07-07, bod 9).
 *
 * @return {void}
 */
function lockScroll() {
	lockScrollY = window.scrollY || window.pageYOffset || 0;
	document.body.style.position = 'fixed';
	document.body.style.top = '-' + lockScrollY + 'px';
	document.body.style.width = '100%';
	window.addEventListener('orientationchange', onLockOrientation);
}

/**
 * Odemkne rolovani a vrati stranku PRESNE tam, kde byla.
 *
 * Poradi je podstatne: styly se odeberou a pozice obnovi JESTE PRED tim,
 * nez ze <body> zmizi stav `menu-open` -- jinak by mezi odemknutim a
 * obnovenim pozice probliknul skok na zacatek stranky.
 *
 * @return {void}
 */
function unlockScroll() {
	window.removeEventListener('orientationchange', onLockOrientation);
	document.body.style.removeProperty('position');
	document.body.style.removeProperty('top');
	document.body.style.removeProperty('width');
	window.scrollTo(0, lockScrollY);
}

/**
 * Otevre panel.
 *
 * @return {void}
 */
function open() {
	if (isOpen()) {
		return;
	}

	/*
	 * ZAZNAM DO HISTORIE MUSI BYT PRVNI, JESTE PRED ZAMKEM SCROLLU.
	 *
	 * Namereno harnessem `_07-menu.cjs` (07-07): `lockScroll()` prepne telo
	 * na `position: fixed`, cimz `window.scrollY` okamzite spadne na 0.
	 * Kdyby se `pushState()` volalo az potom, prohlizec by si k PUVODNIMU
	 * zaznamu historie ulozil pozici 0 -- a `history.back()` v `close()` by
	 * pak stranku vratil na zacatek, i kdyz `unlockScroll()` spravne
	 * odroloval zpet na 400 px. Dva mechanismy by si odporovaly a vyhral by
	 * ten pozdejsi (obnova historie).
	 */
	if (window.history && 'function' === typeof window.history.pushState) {
		// Konstantni objekt, nikdy uzivatelsky vstup (threat T-07-03-02).
		window.history.pushState({ th2026Menu: true }, '');
		pushedHistory = true;
	}

	document.documentElement.style.setProperty('--th-scrollbar-gap', scrollbarGap() + 'px');

	panel.removeAttribute('hidden');
	lockScroll();
	setState(STATE, true);
	isolateDocument();

	burger.setAttribute('aria-expanded', 'true');
	const closeLabel = burger.getAttribute('data-label-close');
	if (closeLabel) {
		burger.setAttribute('aria-label', closeLabel);
	}

	document.addEventListener('keydown', onKeydown);
	document.addEventListener('focusin', onFocusOutside);

	/*
	 * Fokus na prvni prvek PANELU (ne prvni prvek trapu -- tim je
	 * hamburger, na kterem fokus uz je). Kdyz je panel prazdny, fokus
	 * zustava na tlacitku.
	 */
	const items = focusables();
	if (items.length > 1) {
		items[1].focus();
	}
}

/**
 * Zavre panel a vrati fokus na hamburger.
 *
 * @param {boolean} [fromHistory] true = zavolano z popstate; nesmi znovu
 *                                sahat na historii.
 * @param {boolean} [skipBack]    true = zavreni kvuli aktivaci skutecneho
 *                                navigacniho cile uvnitr panelu (kotva),
 *                                ne kvuli Escape/klik mimo/hamburger --
 *                                `pushedHistory` zaznam se ZAHODI (viz
 *                                nize), ale BEZ volani `history.back()`,
 *                                aby se neprepsala/nezrusila hash navigace,
 *                                kterou uz mezitim provedl prohlizec sam
 *                                jako default akci tehoz kliku (duvod
 *                                a zmereny dopad viz `onPanelClick()`).
 * @return {void}
 */
function close(fromHistory, skipBack) {
	if (!isOpen()) {
		return;
	}

	/*
	 * Posluchace se odebiraji JAKO PRVNI: `restoreDocument()` i `burger.focus()`
	 * niz by jinak vystrelily `focusin` a trap by fokus vratil do panelu,
	 * ktery se prave zavira.
	 */
	document.removeEventListener('keydown', onKeydown);
	document.removeEventListener('focusin', onFocusOutside);

	restoreDocument();

	panel.setAttribute('hidden', '');
	unlockScroll();
	setState(STATE, false);

	burger.setAttribute('aria-expanded', 'false');
	const openLabel = burger.getAttribute('data-label-open');
	if (openLabel) {
		burger.setAttribute('aria-label', openLabel);
	}

	document.documentElement.style.removeProperty('--th-scrollbar-gap');

	burger.focus();

	if (!fromHistory && pushedHistory) {
		pushedHistory = false;
		if (!skipBack) {
			window.history.back();
		}
	}
}

/**
 * Inicializace modulu.
 *
 * Fail-open: kdyz panel nebo hamburger v dokumentu nejsou (jina sablona
 * stranky, budouci varianta hlavicky), modul se tise vrati. Nic dalsiho
 * na nem nestoji.
 *
 * POSLEDNI RADEK JE SOUCAST KONTRAKTU (07-07, bod 1): `menu-ready` se na
 * <html> dostane teprve tehdy, kdyz vsechno vyse probehlo bez vyjimky.
 * Kdyz cokoli spadne driv, trida nepribude, hamburger zustane skryty
 * (`visibility: hidden`) a CSS fallback po 2 s odkryje svislou navigaci.
 * Pridavat sem cokoli ZA tenhle radek znamena tvrdit, ze na tom uz
 * pripravenost menu nezavisi.
 *
 * @return {void}
 */
function init() {
	panel = document.getElementById(PANEL_ID);
	burger = document.querySelector(BURGER_SELECTOR);

	if (!panel || !burger) {
		return;
	}

	burger.addEventListener('click', () => {
		if (isOpen()) {
			close();
		} else {
			open();
		}
	});

	panel.addEventListener('click', onPanelClick);

	window.addEventListener('popstate', onPopstate);

	if (window.matchMedia) {
		const desktop = window.matchMedia(DESKTOP_QUERY);
		if (desktop.addEventListener) {
			desktop.addEventListener('change', onDesktop);
		} else if (desktop.addListener) {
			// Safari 13/14: addEventListener na MediaQueryList jeste neni.
			desktop.addListener(onDesktop);
		}
	}

	document.documentElement.classList.add(READY_CLASS);
}

export { init, open, close, isOpen };
